import styled from 'styled-components'

import { styleMixins } from '../../../../../style'
import { defaultTextStyle } from '../../../../../style/styleMixins/text'

const { getSpacing } = styleMixins.offset

export const CommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${getSpacing(3)};

  @media ${(p) => p.theme.breakpoints.mobile} {
    padding: ${getSpacing([0, 0, 2, 0])};
  }
`

export const ContentWrapp = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${getSpacing(4)};
  gap: ${getSpacing(2)};

  @media ${(p) => p.theme.breakpoints.tablet} {
    width: 100%;
  }
`

export const SSButton = styled.div`
  display: flex;
  width: 300px;

  @media ${(p) => p.theme.breakpoints.mobile} {
    width: 250px;
  }
`

export const SBodyTextWrapp = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${getSpacing([1])};
`

export const SFooterComment = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`

export const SCreated = styled.div`
  margin: 0;
  padding: 0;
  ${defaultTextStyle(2)};
  color: ${(p) => p.theme.colors.grey_450};
`

export const SHeaderTitle = styled.p`
  margin: 0;
  padding: 0;
  ${defaultTextStyle(2)};'
`
export const STitleText = styled.p`
  margin: 0;
  padding: 0;
  ${defaultTextStyle(6)};
`
export const SText = styled.p`
  margin: 0;
  padding: 0;
  ${defaultTextStyle(1)};
  color: ${(p) => p.theme.colors.grey_450};
`
